module.exports = __webpack_public_path__ + "assets/img/62005304a7ce2a0762ff65588b645888.png";